import React, { useState } from 'react';

const AddFolderModal = ({ onClose, onAdd }) => {
  const [name, setName] = useState('');
  const [color, setColor] = useState('blue');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) return;

    setLoading(true);
    const created = await onAdd({ name, color });
    setLoading(false);
    if (created) onClose();
  };

  const ColorRadio = ({ value, bgClass, activeRing }) => (
    <label className="cursor-pointer relative">
      <input 
        type="radio" 
        name="folderColor" 
        value={value} 
        checked={color === value}
        onChange={() => setColor(value)}
        className="hidden" 
      />
      <div className={`w-6 h-6 rounded-full ${bgClass} ${color === value ? `ring-2 ring-offset-1 ${activeRing}` : ''} transition-all shadow-sm`}></div>
    </label>
  );

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 relative animate-in fade-in zoom-in duration-200">
        
        <h3 className="text-lg font-bold text-slate-900 mb-1 text-center">New Subject Folder</h3>
        <p className="text-xs text-slate-500 mb-6 text-center">Keep your study materials organized.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <div className="flex justify-between items-center mb-2 ml-1">
              <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest">Name</label>
              <span className="text-[10px] font-semibold text-slate-400">{name.length}/30</span>
            </div>
            <input 
              type="text" 
              placeholder="e.g. Microbiology" 
              className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 outline-none text-base md:text-sm transition shadow-sm" 
              value={name}
              onChange={(e) => setName(e.target.value)}
              maxLength={30}
              required 
              disabled={loading}
            />
          </div>

          <div className="mb-6">
            <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 ml-1">Theme Color</label>
            <div className="flex gap-3 justify-center py-3 bg-slate-50 rounded-xl border border-slate-100">
              <ColorRadio value="blue" bgClass="bg-blue-500" activeRing="ring-blue-300" />
              <ColorRadio value="orange" bgClass="bg-orange-500" activeRing="ring-orange-300" />
              <ColorRadio value="purple" bgClass="bg-purple-500" activeRing="ring-purple-300" />
              <ColorRadio value="green" bgClass="bg-emerald-500" activeRing="ring-emerald-300" />
              <ColorRadio value="red" bgClass="bg-red-500" activeRing="ring-red-300" />
              {/* ✅ Added Gray Option */}
              <ColorRadio value="gray" bgClass="bg-gray-500" activeRing="ring-gray-300" />
            </div>
          </div>

          <div className="flex gap-3">
            <button 
                type="button" 
                onClick={onClose} 
                className="flex-1 px-4 py-3 rounded-xl text-slate-500 text-xs font-bold hover:bg-slate-50 transition"
            >
                Cancel
            </button>
            <button 
                type="submit" 
                disabled={loading}
                className="flex-1 px-4 py-3 rounded-xl bg-blue-600 text-white text-xs font-bold hover:bg-blue-700 shadow-lg shadow-blue-200 transition-all flex items-center justify-center"
            >
              {loading ? <i className="fa-solid fa-spinner animate-spin"></i> : 'Create Folder'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFolderModal;
